"use client";

import { useLayoutEffect } from "react";

const storageKey = "theme";

export default function ThemeInit() {
  useLayoutEffect(() => {
    try {
      const stored = window.localStorage.getItem(storageKey);
      const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
      const theme = stored === "light" || stored === "dark" ? stored : prefersDark ? "dark" : "light";
      document.documentElement.classList.toggle("dark", theme === "dark");
    } catch (error) {}
  }, []);

  return null;
}
